import * as React from 'react';
import { IAsidePanelCommentsColumnViewButtonProps } from './types';
import './_AsidePanelCommentsColumnViewButton.scss';
import { Button } from 'kui';
import { CLASS_ASIDE_PANEL } from '../../constants';
import {
    ASIDE_PANE_COMMENTS_COLUMN_ANIMATION,
    ASIDE_PANE_COMMENTS_COLUMN_HIGHLIGHT_ANIMATION,
    ASIDE_PANE_COMMENTS_COLUMN_HINT,
    ASIDE_PANE_COMMENTS_COLUMN_TOOLTIP,
    ASIDE_PANE_COMMENTS_COLUMN_TOOLTIP_COLUMNS
} from './constants';
import { getAsidePanelTooltip } from '../../helpers/getAsidePanelTooltip';
import { AsidePanelContext } from '../AsidePanel/constants';
import { EHintKey, HintHOC } from '../../../../hints';

export function AsidePanelCommentsColumnViewButton({
    isNew,
    isShow,
    onClick,
    onHintHide,
}: IAsidePanelCommentsColumnViewButtonProps) {
    const className = CLASS_ASIDE_PANEL + '__ccv-button';

    const { isCommentsColumn } = React.useContext(AsidePanelContext);

    const [isDisabled, setDisabled] = React.useState(null);
    const [isShowHint, setShowHint] = React.useState(null);

    React.useEffect(() => {
        return () => onHintHide();
    }, []);

    React.useEffect(() => {
        if (!isNew) return;
        setTimeout(() => {
            setShowHint(true);
        }, ASIDE_PANE_COMMENTS_COLUMN_HIGHLIGHT_ANIMATION * 3);
    }, [isNew]);

    if (!isShow) return null;

    const OneColumnIcon = require('!!@svgr/webpack!./one-column.svg').default;
    const TwoColumnIcon = require('!!@svgr/webpack!./two-column.svg').default;

    return <>
        {isShowHint &&
            <HintHOC
                className={className + '-hint'}
                key={EHintKey.ASIDE_COLUMN_TOGGLE}
                hintKey={EHintKey.ASIDE_COLUMN_TOGGLE}
                show
                arrow={'right'}
                direction={'left'}
                value={ASIDE_PANE_COMMENTS_COLUMN_HINT}
                selector={`.${className}`}
                isHideOnAnyClick
            />
        }
        <Button
            className={`${className} ${isNew && !isShowHint ? className + '--highlight' : ''}`}
            tooltip={getAsidePanelTooltip({
                value: isCommentsColumn ? ASIDE_PANE_COMMENTS_COLUMN_TOOLTIP_COLUMNS : ASIDE_PANE_COMMENTS_COLUMN_TOOLTIP,
                direction: 'down',
            })}
            variant={'icon'}
            onClick={() => {
                onClick();
                setDisabled(true);
                setTimeout(() => setDisabled(false), ASIDE_PANE_COMMENTS_COLUMN_ANIMATION);
            }}
            disabled={isDisabled}
        >
            {isCommentsColumn ? <OneColumnIcon /> : <TwoColumnIcon />}
        </Button>
    </>;
}
